export default "__VITE_ASSET__uvziS$xE__";